import { InspectorListItem } from "@/model/InspectorListItem.ts";
import { PageReq, PageRes } from "../PageDto";
import { Type } from "class-transformer";

/**
 * 점검 사용자 리스트 조회 - req
 */
export class ReadInspectorListReqDto extends PageReq {}

/**
 * 점검 사용자 리스트 조회 - res
 */
export class ReadInspectorListResDto extends PageRes<InspectorListItem> {
    @Type(() => InspectorListItem)
    declare content: InspectorListItem[];
}
